<div class="cover-image">
  <app-page-header backLabel="Back" (back)="backto()"></app-page-header>
  <div class="p-20">
    <span style="display:inline-block;margin-bottom:14px"><span
        style="font-weight:600;font-size:27px">Announcements</span></span>
    <div id="announcements">
      <div style="display:flex;margin-bottom:14px" fxLayout.xs="column">
        <div style="flex:2">
          <topaz-search [simpleSearch]="true" placeholder="Search announcements" (search)="onSearch($event)"
            (clear)="onClearSearch()" clearButtonAriaLabel="clear search" id="simpleSearch"></topaz-search>
        </div>
      </div>

      <div style="background-color: #fff;padding:32px;border-radius:8px" class="dialog-form-field-container">
        <div id="ann-container" *ngFor="let announcement of announcements;let i=index">

          <div class="demo-card-header-pattern" appearance="raised" aria-labelledby="long-card-title" id="cardPattern2">
            <div class="left-content">
              <div class="left-footer">
                <p *ngIf="announcement?.title" class="footer-badge-line"
                  style="color:black;font-weight:600;margin-bottom:1rem;">
                  {{announcement?.title}}<span style="display:inline-block" class="topaz-padding-left-16"><topaz-capsule
                      class="custom-capsule" small id="fullWidthPrimary">New</topaz-capsule></span>
                </p>
                <span *ngIf="announcement?.description"
                  style="color:#525252;font-weight:200;margin-bottom:20px;width:150%;text-transform: capitalize;margin-left:5px">
                  {{announcement?.description}}
                </span>
              </div>

              <button *ngIf="announcement?.url" mat-button id="primaryTextBtn" color="secondary" aria-label="read more"
                (click)="viewancmt(announcement)">
                <fa-icon style="margin-right:5px;" [icon]="icons.faArrowUpRightFromSquare"></fa-icon>
                Read more
              </button>
            </div>
            <mat-divider *ngIf="i>=0" style="margin-top:15px;border-color:neutral/300;" />
          </div>
        </div>
        <div *ngIf="announcements?.length === 0" class="no-announcements">
          <p>No announcements match your search</p>
        </div>
        <div *ngIf="(announcements?.length < totalElements) && !last" (click)="loadMore()" class="loadMore tempoutline">
          <button mat-button id="basicTextBtn" aria-label="basic">Show more</button>
        </div>
      </div>
    </div>
  </div>
</div>